import React, {useState} from "react";
import './fileUploader.css';

import {ReactComponent as ClearIcon} from "../../../images/icons/ui/clear.svg";
import {ReactComponent as ReplaceIcon} from "../../../images/icons/ui/replace.svg";
import {ReactComponent as DownloadIcon} from "../../../images/icons/ui/download.svg";
import {Fingerprint} from "../../../utils/storage";
import Button from "../button/button";


function FileUploader({
                          title,
                          description,
                          imageBase64,
                          url,
                          uploadHandler,
                          size,
                          uploadOutsideHandler,
                          buttonLabel,
                          isTypeVideo,
                          startLoaderHandler,
                          imageUploaderID
                      }) {
    const [internalId, setInternalId] = useState(imageUploaderID ? imageUploaderID : Fingerprint.hashFunc(String(Math.random())))
    const [showUrl, setShowUrl] = useState(true)

    if (['small', 'large'].indexOf(size) < 0) {
        size = 'large'
    }

    const handleClick = () => {
        if (uploadOutsideHandler) uploadOutsideHandler()
        else document.getElementById(`image-${internalId}`).click()
    };

    const fileInputChange = (event) => {
        if (isTypeVideo) {
            startLoaderHandler(1)
            const target = event.target;
            if (target.files && target.files[0]) {
                const file = target.files[0];
                const fileName = file.name;

                if (uploadHandler) {
                    uploadHandler(file, fileName)

                }
            }
        } else {
            startLoaderHandler(20)
            const target = event.target;
            if (target.files && target.files[0]) {
                const file = target.files[0];
                const fileName = file.name;

                const reader = new FileReader();
                reader.onload = (event) => {
                    let base64String = event.target.result;
                    if (uploadHandler) uploadHandler(base64String, fileName);
                };
                reader.readAsDataURL(file);
            }
        }
    };

    let previewClass = ['FileUploader-preview']
    if (size === 'small') previewClass.push('FileUploader-preview-small')
    else if (size === 'large') previewClass.push('FileUploader-preview-large')

    return <div className="FileUploader">
        {title ? <div className="FileUploader-title">{title}</div> : null}

        {description ? <div className="FileUploader-description">{description}</div> : null}

        <div className={previewClass.join(' ')}>
            {
                imageBase64 || (showUrl && url) ? (
                    <>
                        <div className="FileUploader-preview-buttons">
                            <Button customClass="FileUploader-preview-button"
                                    type='transparent' size='small'
                                    startIcon={<DownloadIcon/>}
                                    onClick={() => {
                                        const downloadUrl = imageBase64 ? imageBase64 : (showUrl ? url : null);
                                        if (downloadUrl) {
                                            // откроется в новой вкладке
                                            window.open(downloadUrl, "_blank");

                                            // если нужно именно скачать, можно так:
                                            // const a = document.createElement('a');
                                            // a.href = downloadUrl;
                                            // a.download = "file"; // можно задать имя файла
                                            // a.click();
                                        }
                                    }}
                            >
                                Скачать
                            </Button>
                            <Button customClass="FileUploader-preview-button"
                                    type='transparent' size='small'
                                    startIcon={<ReplaceIcon/>}
                                    onClick={handleClick}
                            >
                                Заменить
                            </Button>
                            <Button customClass="FileUploader-preview-button"
                                    type='transparent' size='small'
                                    startIcon={<ClearIcon/>}
                                    onClick={() => {
                                        if (uploadHandler) {
                                            uploadHandler(null);
                                            setShowUrl(false)
                                        }
                                    }}>
                                Очистить
                            </Button>
                        </div>
                    </>
                ) : null
            }
            <Button
                customClass='FileUploader-upload-button'
                style={{display: imageBase64 || (showUrl && url) ? 'none' : 'flex'}}
                onClick={handleClick}
                type='primary'
                size='medium'
            >
                {buttonLabel ? buttonLabel : "Загрузить"}
                <input
                    id={`image-${internalId}`}
                    name='image'
                    type='file'
                    accept='*/*'
                    className='FileUploader-hidden-input'
                    onChange={(event) => fileInputChange(event)}
                />
            </Button>
        </div>
    </div>
}

export default FileUploader;